import { CHATBOT_API_CONFIG } from './chatbot-api.config';
import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { ChatbotAnswer, LangEnum } from '@wizbii/utils/models';
import { Observable } from 'rxjs';

@Injectable()
export class ChatbotWebservice {
  readonly #httpClient = inject(HttpClient);
  readonly #chatbotApiConfig = inject(CHATBOT_API_CONFIG);

  readonly #baseUrl = this.#chatbotApiConfig.baseUrl;

  sendMessage(sessionId: string, lang: LangEnum, userId?: string, query?: string): Observable<ChatbotAnswer> {
    return this.#httpClient.post<ChatbotAnswer>(`${this.#baseUrl}/predict`, {
      lang,
      sessionId,
      userId,
      query,
    });
  }
}
